import { useTranslation } from 'react-i18next';
import { BellRingingIcon, CircleNotchIcon } from '@phosphor-icons/react';
import { TaskType } from '@monorepo/shared';
import type { TaskDto } from '@monorepo/shared';
import { isActionableStatus } from './taskDisplay';

interface TaskAllScopeActionsProps {
  task: TaskDto;
  isReminderPending: boolean;
  onViewDocument: (task: TaskDto) => void;
  onSendReminder: (task: TaskDto) => void;
}

const REMINDABLE_TYPES = [TaskType.VALIDATION, TaskType.READ];

export const TaskAllScopeActions = ({
  task,
  isReminderPending,
  onViewDocument,
  onSendReminder,
}: TaskAllScopeActionsProps) => {
  const { t } = useTranslation();

  const canRemind = isActionableStatus(task.status) && REMINDABLE_TYPES.includes(task.type);

  return (
    <div className="flex flex-col gap-2 lg:flex-row lg:justify-end">
      {canRemind && (
        <button
          type="button"
          onClick={() => onSendReminder(task)}
          disabled={isReminderPending}
          className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary px-4 py-1.5 text-sm font-medium text-primary transition hover:bg-primary hover:bg-opacity-10 disabled:opacity-50"
        >
          {isReminderPending ? (
            <CircleNotchIcon size={16} className="animate-spin" weight="bold" />
          ) : (
            <BellRingingIcon size={16} />
          )}
          {t('tasks.action.remind')}
        </button>
      )}

      <button
        type="button"
        onClick={() => onViewDocument(task)}
        disabled={!task.nodeId}
        className="whitespace-nowrap rounded-md border border-gray-300 px-4 py-1.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-50"
      >
        {t('tasks.action.view')}
      </button>
    </div>
  );
};
